<div class="img-container" [class.blur-10]="inDemoMode">
  <div class="center-align-helper" i18n>This will help alignment in printing</div>
  <img #viewImageElement [src]="imageSrcUrl" [style.visibility]="isImageVisible ? 'visible': 'hidden'" ondragstart="return false;" (load)="onImageLoad()" (mousedown)="startPan()">
</div>